// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-0ee1eb1f]{padding:1rem 0}@media(min-width: 48em){.container--columns[data-v-0ee1eb1f]{display:-webkit-box;display:flex;gap:1.5rem}.container--columns-template-width-30[data-v-0ee1eb1f]{width:30%}.container--columns-template-width-70[data-v-0ee1eb1f]{width:70%}.container--columns-template-width-50[data-v-0ee1eb1f]{width:50%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
